var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-muted text-muted font-italic text-center"},[_c('p',{staticClass:"m-0 py-5"},[_vm._v(" Not implemented yet ")])])}]

export { render, staticRenderFns }